import { render, staticRenderFns } from "./RecordAnswerInput.vue?vue&type=template&id=25ee59ff"
import script from "./RecordAnswerInput.vue?vue&type=script&lang=ts"
export * from "./RecordAnswerInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports